import "core-js/modules/es6.array.map.js";
import _ from 'lodash';
export var roles = function roles(state) {
  // const user = state.currentUser
  // if (user) {
  //   user.roles.push(user.role)
  //   return user.roles
  // }
  return [];
};
export var currentUser = function currentUser(state) {
  return state.currentUser;
};
export var permissions = function permissions(state) {
  return _.groupBy(_.uniqBy(_.flatten(roles(state).map(function (role) {
    return role.permissions;
  })), 'key'), 'table_name');
};